import React from "react";
import { Link } from "react-router-dom";
import LabShell from "@/components/LabShell";

export default function NotFound() {
  return (
    <LabShell>
      <section className="pt-20 pb-28 max-w-[58ch]">
        <p
          className="text-xs uppercase mb-4"
          style={{ color: "#8C8198", fontFamily: "'Courier Prime', monospace", letterSpacing: "0.22em" }}
        >
          404 · wrong note
        </p>
        <h1
          className="text-4xl sm:text-5xl lg:text-6xl leading-[1.05] mb-5"
          style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 600 }}
          data-testid="notfound-title"
        >
          That experiment is <span style={{ color: "#8A6514" }}>somewhere else</span>.
        </h1>
        <p className="text-base mb-8" style={{ color: "#5C5268", lineHeight: 1.8 }}>
          Nothing is broken — this page just isn&apos;t on the bench. Try one of the toys
          that is.
        </p>
        <div className="flex flex-wrap gap-3">
          <Link
            to="/harp"
            data-testid="notfound-harp"
            className="rounded-full px-6 py-3 text-xs"
            style={{ backgroundColor: "#D99B26", color: "#fff", fontFamily: "'Courier Prime', monospace", letterSpacing: "0.16em" }}
          >
            PLAY DAVID&apos;S HARP
          </Link>
          <Link
            to="/alephonics"
            data-testid="notfound-alephonics"
            className="rounded-full px-6 py-3 text-xs"
            style={{ backgroundColor: "#1B6C7A", color: "#fff", fontFamily: "'Courier Prime', monospace", letterSpacing: "0.16em" }}
          >
            TRANSLATE HEBREW
          </Link>
          <Link
            to="/"
            className="rounded-full px-6 py-3 text-xs"
            style={{ border: "1px solid #D6CBB8", color: "#5C5268", fontFamily: "'Courier Prime', monospace", letterSpacing: "0.16em" }}
          >
            THE LAB
          </Link>
        </div>
      </section>
    </LabShell>
  );
}
